import axiosClient from "@/services/api/index";
import {
  ColorSchemeInterface,
  CreateColorSchemeInterface,
  ExternalColorSchemeInterface,
  QueryColorSchemeInterface,
  QueryExternalColorSchemeInterface,
  QueryInternalColorSchemeInterface,
  UpdateColorSchemeInterface,
  EstateColorSchemeInterface,
  CreateEstateColorSchemeInterface,
  UpdateEstateColorSchemeInterface,
} from "@/types/ColorSchemeInterface";

export default {
  async createColorScheme(
    params: CreateColorSchemeInterface
  ): Promise<ExternalColorSchemeInterface> {
    return axiosClient
      .post("color-scheme", params)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async uploadImageColorScheme(
    builderId: string,
    image: FormData
  ): Promise<unknown> {
    return axiosClient
      .post(`color-scheme/images/${builderId}`, image)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async getColorSchemeByQuery(
    params: QueryColorSchemeInterface
  ): Promise<ColorSchemeInterface[]> {
    return axiosClient
      .get("color-scheme", { params })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async deleteColorScheme(id: string): Promise<void> {
    return axiosClient
      .delete(`color-scheme/${id}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async updateColorScheme(
    dto: UpdateColorSchemeInterface,
    id: string
  ): Promise<void> {
    return axiosClient
      .patch(`color-scheme/${id}`, dto)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  // ── Estate colour scheme methods ──────────────────────────────────────────────

  async createEstateColorScheme(
    params: CreateEstateColorSchemeInterface
  ): Promise<EstateColorSchemeInterface> {
    return axiosClient
      .post("color-scheme/for-estate", params)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async getColorSchemesByEstateId(
    estateId: string
  ): Promise<EstateColorSchemeInterface[]> {
    return axiosClient
      .get(`color-scheme/estate/${estateId}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async updateEstateColorScheme(
    dto: UpdateEstateColorSchemeInterface,
    id: string
  ): Promise<void> {
    return axiosClient
      .patch(`color-scheme/estate/${id}`, dto)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async deleteEstateColorScheme(id: string): Promise<void> {
    return axiosClient
      .delete(`color-scheme/${id}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async uploadEstateImage(
    estateId: string,
    formData: FormData
  ): Promise<{ url: string }> {
    return axiosClient
      .post(`color-scheme/estate-images/${estateId}`, formData)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },
};
